var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { class: _vm.positionClass }, [
        _c("button", {
          staticClass: "widget-pane-toggle-button",
          class: _vm.expandoClass,
          attrs: { "aria-label": "Collapse side panel" },
          on: { click: _vm.expandoClicked },
        }),
      ]),
      _vm._v(" "),
      _vm.position === "left"
        ? _c("v-slide-x-transition", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showPanel,
                    expression: "showPanel",
                  },
                ],
                class: _vm.contentCss,
                attrs: { id: _vm.contentId },
              },
              [_vm._t("default")],
              2
            ),
          ])
        : _c("v-slide-x-reverse-transition", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showPanel,
                    expression: "showPanel",
                  },
                ],
                class: _vm.contentCss,
                attrs: { id: _vm.contentId },
              },
              [_vm._t("default")],
              2
            ),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }